/* 🤖 this file was generated by script */
export const wsolidiconDiamond01 = {
  name: 'diamond_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12.61 2H11.4l-2 6h5.22zM14.61 10H9.4L12 17.84zM7.28 8l2-6H7.23c-.44 0-.86.2-1.15.54L2.21 7.18A.5.5 0 0 0 2.6 8zM2.21 10.82A.5.5 0 0 1 2.6 10h4.68l3.51 10.54c.08.22-.17.38-.32.19l-.16-.2zM16.72 10h4.68c.42 0 .66.5.38.82l-8.1 9.72-.15.19c-.15.19-.4.03-.32-.2zM21.78 7.18a.5.5 0 0 1-.38.82h-4.68l-2-6h2.05c.44 0 .86.2 1.15.54z"/></svg>`,
  iconStyle: 'solid',
};
